module.exports = __webpack_public_path__ + "img/IMG_0300_L_Black_MockedUp.baca5a8c.jpg";